// InflowsDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import DirectInflowsForm from './DirectInflowsForm'
import DryWeatherForm from './DryWeatherForm'
import RDIIForm from "./RDIIForm"
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function InflowsDialog({model, setModel, targetType, target}) {
  const [submodel, setSubmodel] = useState({})

  useEffect(()=>{
    let INFLOWS = {}
    let RDII    = {}
    let DWF     = {}

    if(model.INFLOWS && model.INFLOWS[target]){
      if(model.INFLOWS[target].FLOW){
        INFLOWS = {
          [target]: model.INFLOWS[target]
        }
      } else {
        INFLOWS = {
          [target]: {
           ...model.INFLOWS[target],
           "FLOW": {
              "Timeseries": "",
              "Type": "FLOW",
              "UnitsFactor": 1,
              "ScaleFactor": 0,
              "Baseline": "",
              "Pattern": ""
            }
          }
        }
      }
    } else {
      INFLOWS = {
        [target]:{
          "FLOW": {
            "Timeseries": "",
            "Type": "FLOW",
            "UnitsFactor": 1,
            "ScaleFactor": 0,
            "Baseline": "",
            "Pattern": ""
          }
      }}
    }

    if(model.RDII && model.RDII[target]){
      RDII = {
        [target]: model.RDII[target]
      }
    } else {
      RDII = {
        [target]:{
          UHgroup: "",
          SewerArea: 0
      }}
    }

    if(model.DWF && model.DWF[target]){
      DWF = {
        [target]: model.DWF[target]
      }
    } else {
      DWF = {
        [target]:{
          "FLOW":{
            "Base": 0,
            "Pat1": "\"\"",
            "Pat2": "\"\"",
            "Pat3": "\"\"",
            "Pat4": "\"\"",
            "Pat5": "",
            "Pat6": "",
            "Pat7": ""
          }
      }}
    }

    setSubmodel({
      INFLOWS: INFLOWS,
      RDII:    RDII,
      DWF:     DWF
    })
  },[])

  const saveEdits = () => {
    // If baseline is "", set it to 0. If scaleFactor is "", set it to 1.
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    for(let constituent in cleanSub.INFLOWS[target]){
      if(isNaN(cleanSub.INFLOWS[target][constituent].ScaleFactor)){
        cleanSub.INFLOWS[target][constituent].ScaleFactor = 1
      }
      if(isNaN(cleanSub.INFLOWS[target][constituent].Baseline)){
        cleanSub.INFLOWS[target][constituent].Baseline = 0
      }
      // For DWF, if Base is "", set it to 0
      if(isNaN(cleanSub.DWF[target][constituent].Base)){
        cleanSub.DWF[target][constituent].Base = 0
      }
    }
    setModel(prev => ({
      ...prev,
      INFLOWS:{
        ...prev.INFLOWS, 
        [target]: cleanSub.INFLOWS[target]
      },
      RDII:{
        ...prev.RDII, 
        [target]:
          cleanSub.RDII[target]
      },
      DWF:{
        ...prev.DWF, 
        [target]:
          cleanSub.DWF[target]
      }
    }))
  }

  function openTab(evt, tabName) {
    var i, tabcontent, tablinks
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent")
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none"
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks")
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "")
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block"
    evt.currentTarget.className += " active"
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  return(
    <>
    {
      <>
        <Typography id="modal-modal-title" variant="p4" >
          <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
            <label>Inflows for Node {target}</label>
          </div>
        </Typography>
        <div className="controlcol" >  
          {
            <>
            <div className="controlrow" style={{background:"black"}}>
              {
              }
              </div>
            </>
          }
        </div>
        <div>
          <Button fullWidth onClick={saveEdits} >Save Edits</Button>
        </div>
        <div style={{height: "280px", background:'black', overflowY: 'hidden', paddingBottom:"120px"}}>
          {
            targetType && 
            targetType in model && 
            target &&
            target in model[targetType] &&
            <>
            <div className="tab">
              <button className="tablinks" onClick={(e)=>openTab(e, 'Direct')}>Direct</button>
              <button className="tablinks" onClick={(e)=>openTab(e, 'Dry Weather')}>Dry Weather</button>
              <button className="tablinks" onClick={(e)=>openTab(e, 'RDII')}>RDII</button>
            </div>
            
            <div id="Direct" style={{display: 'block'}} className="tabcontent active">
              <DirectInflowsForm model={submodel} setModel={setSubmodel} fullModel={model} targetType={targetType} target={target} />
            </div>

            <div id="Dry Weather" className="tabcontent">
              <DryWeatherForm model={submodel} setModel={setSubmodel} fullModel={model} targetType={targetType} target={target} />
            </div>

            <div id="RDII" className="tabcontent">
              <RDIIForm model={submodel} setModel={setSubmodel} fullModel={model} targetType={targetType} target={target} />
            </div>
            <div className="infocol">
              

            </div>
            </>
          }
        </div>
        </>
      }
    </>
  )
}